import { css } from 'styled-components';
import {
  FacilitiesContainerStyles,
  overnightFlightsContainerStyles,
} from '@/app/components/search/components/OvernightFlightsMessage/styled';
import { FlightContainerStyles } from './Fields/getFlightField/styled';
import { propertyNameStyles } from './Fields/getProprtyNameField/styled';
import { DiscountContainerStyles } from './Fields/getDiscountFields/styled';

const adjustSectionContainerSpacing = css`
  #BookingOptionsContainer,
  #DiscountsContainer,
  #PropertyTypeContainer,
  #StarsContainer,
  #RatingContainer,
  #FacilitiesContainer,
  #AccommodationThemesContainer,
  #DestinationAirportContainer,
  #FlightContainer {
    .container-controls {
      padding-top: 4px;
      padding-bottom: 4px;
    }
  }
`;

export const filters = css`
  .oss-ui-form {
    width: 100%;
    background-color: transparent;
    padding: 0;
    overflow: visible;
  }
  ${FlightContainerStyles};
  ${propertyNameStyles};
  ${DiscountContainerStyles};
  ${overnightFlightsContainerStyles};
  ${FacilitiesContainerStyles};
  ${adjustSectionContainerSpacing};
`;
